import PublicInteractiveRoleplay from './container/PublicInteractiveRoleplay';
import SubmitPublicInteractiveRoleplay from './container/SubmitPublicInteractiveRoleplay';
export const interactiveRoleplaysRoutes = [
  {
    path: '/public-roleplay/:token',
    component: PublicInteractiveRoleplay,
    key: 'public-roleplay',
  },
  {
    path: '/public-roleplay/:token/submit',
    component: SubmitPublicInteractiveRoleplay,
    key: 'public-roleplay-submit',
  },
];
